// ----------------------------------------------------------------------

export function accordion(theme) {
  return {
    MuiAccordion: {
      defaultProps: {
        variant: 'outlined',
      },
      styleOverrides: {
        root: {
          boxShadow: 'none',
          width: '100%',
          '&:not(:last-of-type)': {
            borderBottom: 0,
          },
          '& + .MuiAccordion-root:not(.Mui-expanded)': {
            borderTop: 0,
          },
          '&.Mui-expanded': {
            margin: 0,
          },
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
      },
    },
  };
}
